module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/box-model/box-model.component.scss
// module id = ./src/app/features/box-model/box-model.component.scss
// module chunks = main